new Swiper('.image-banner-slider', {
    slidesPerView: 1,
    loop:true,
    paginationClickable: true,
    autoplay: {
        delay: 2500,
      },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});